import gijsFace from './gijs.jpg'

export default buildMonster = (cb) ->

  loader = new THREE.TextureLoader();
  loader.load(
    gijsFace,
    ( texture ) ->
      material = new THREE.MeshBasicMaterial( {
        map: texture
      })
      geometry = new THREE.BoxGeometry( 50, 50, 50 )
      gijs = new THREE.Mesh( geometry, material )
      AFRAME.scenes[0].object3D.add(
        gijs
      )
      cb(gijs)

  );